import { Controller } from "@hotwired/stimulus"

// Controls live background preview on the Lists edit page
// Expected markup:
// - Controller attached to a container that should receive the background color
//   data-controller="background-preview"
//   data-background-preview-target="container"
//   data-background-preview-default-class="bg-gray-50" (optional; used when no color)
// - Color input marked as a target and wired to input/change events
//   data-background-preview-target="input"
//   data-action="input->background-preview#apply change->background-preview#apply"
export default class extends Controller {
  static targets = ["container", "input"]
  static values = { defaultClass: String }

  connect() {
    // On connect, apply the initial color from the input (if present)
    this.apply()
  }

  apply() {
    const color = this.hasInputTarget ? this.inputTarget.value : null
    const container = this.hasContainerTarget ? this.containerTarget : this.element

    if (!container) return

    if (color && color.trim() !== "") {
      // Apply background color inline and remove default bg class if provided
      container.style.backgroundColor = color
      if (this.hasDefaultClassValue && this.defaultClassValue) {
        container.classList.remove(this.defaultClassValue)
      }
    } else {
      // Clear and restore default class if any
      container.style.backgroundColor = null
      if (this.hasDefaultClassValue && this.defaultClassValue) {
        container.classList.add(this.defaultClassValue)
      }
    }
  }
}
